import { Button, Icons, useToggle } from '@commenda/kakashi';
import {
  LegacyDocumentType,
  TaskStatus,
  TaskParty,
} from '@prisma/client';
import { ServiceRequestTaskLabel } from '../../../common/labels';
import { CorporationUploadFileModal } from '../../../common/modals/CorporationUploadFileModal';
import { ServiceRequestTaskIconConfig } from '../../../common/taskIconConfig';
import { useServiceRequestFile } from '../../../hook/useServiceRequestFile';
import { ServiceRequestTaskCard } from '../../../layout/components/taskCard/ServiceRequestTaskCard';
import { ServiceRequestTaskCardConfig, TCommonTaskProp } from '../../../types';
import { updateTaskStatus, viewUploadedFile } from '../../../utils';
import { IndPvtLtdIncorporationTasks } from '../../IN_PVT_LTD/ind-pvt-ltd';

export const INC20AFilingAcknowledgementTask = ({
  task,
  context,
  isTimelineView = false,
}: TCommonTaskProp) => {
  const { role, serviceRequest, mutate } = context;

  const uploadModalVisibility = useToggle();

  const [file, setFile] = useServiceRequestFile(
    serviceRequest,
    LegacyDocumentType.INC20A
  );

  const handleViewFile = () => viewUploadedFile(file?.id);

  const config: ServiceRequestTaskCardConfig = {
    getLeftIcon: (status) => ServiceRequestTaskIconConfig[status],
    getStateConfig: (state) => {
      const stateMap = {
        [TaskParty.CLIENT]: {
          [TaskStatus.TO_DO]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Commenda uploads acknowledgement" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: task.legacyServiceRequestTaskTaskId ===
              IndPvtLtdIncorporationTasks.UPLOAD_INC_20A_ACKNOWLEDGEMENT && (
              <Button size="sm" variant="secondary" onClick={handleViewFile}>
                View acknowledgement
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel
                label="INC-20A filing completed successfully"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
        },
        [TaskParty.AGENT]: {
          [TaskStatus.TO_DO]: {
            actions: (
              <div className="flex flex-col gap-2">
                <div>
                  <Button
                    size="sm"
                    onClick={uploadModalVisibility.show}
                    variant="primary"
                  >
                    <Icons.Upload01 className="size-4 mr-2" />
                    Upload Acknowledgement
                  </Button>
                </div>
              </div>
            ),
            label: (
              <ServiceRequestTaskLabel label="INC-20A Filing - Upload acknowledgement" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: task.legacyServiceRequestTaskTaskId ===
              IndPvtLtdIncorporationTasks.UPLOAD_INC_20A_ACKNOWLEDGEMENT && (
              <Button size="sm" variant="secondary" onClick={handleViewFile}>
                View acknowledgement
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel
                label="INC-20A filing completed successfully"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
        },
      };

      return (
        stateMap[state.role]?.[state.status] ?? {
          label: task.title,
          actions: null,
        }
      );
    },
  };

  return (
    <div>
      <ServiceRequestTaskCard
        task={task}
        state={{ role, status: task.status }}
        config={config}
        context={context}
        isTimelineView={isTimelineView}
      />
      <CorporationUploadFileModal
        serviceRequestTaskId={task.id}
        file={file}
        setFile={setFile}
        isOpen={uploadModalVisibility.visible}
        setIsOpen={uploadModalVisibility.hide}
        onUploadSuccess={async () => {
          await updateTaskStatus({
            task,
            status: TaskStatus.COMPLETED,
            mutate,
          });
        }}
        documentType={LegacyDocumentType.INC20A}
        heading="Upload INC-20A Acknowledgement"
        serviceRequest={serviceRequest}
      />
    </div>
  );
};
